module.exports = __webpack_public_path__ + "link.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/link.png
// module id = 535
// module chunks = 0